@if (config.currentUser) {
<input type="text" class="search form-control" id="complex-search-input" autocomplete="off" [(ngModel)]="filterKey"
  [placeholder]="'s_fam'| translate | async" (keyup)="onSearchKey($event);" #input />
<a class="dropdown-item highlight" (click)="changeProfileEvent(config.currentUser);"
  [ngClass]="autheticationService.getCurrentUser().user_id == config.currentUser.user_id ? 'active':''"
  href="javascript:void(0);">{{config.currentUser.first_name}}</a>
@for (data of config.data | filterName:{key:'mapped_name',value:filterKey}; track data) {
<a class="dropdown-item" [ngClass]="autheticationService.getCurrentUser().user_id == data.mapped_id ? 'active':''"
  (click)="changeProfileEvent(data);" href="javascript:void(0);">{{data.mapped_name}}</a>
}
@if (autheticationService.getCurrentUser().user_id == config.currentUser.user_id){
<a class="add-member" (click)="addMember();" href="javascript:void(0);">{{'Add Family Member' | translate | async}}</a>
}
}